export enum HeaderTypeOfInformationShown {
    Period,
    Info,
}
